import React from 'react';
import { Grid } from "@mui/material";
import { items } from './quoteDetailsList'
import "./styles.css";

const Items = () => {
  function TotalPartsEstimate() {
    let totall = 0;
    items.map((obj, i) => {
      totall += obj.quantity * obj.price;
    });
    return totall;
  }
  return (
    <Grid container className='item' >
      <div
        style={{
          color: "#000000",
          fontSize: "18px",
          fontWeight: "600",
        }}
      >
        Items Needed
      </div>
      <Grid container spacing={2} pt={2} pb={4} pl={4}>
        <Grid item xs={6}>
          <span style={{ color: "#008EA1" }}>Items name</span>
        </Grid>
        <Grid item xs={3}>
          <span style={{ color: "#008EA1" }}>Nos</span>
        </Grid>
        <Grid item xs={3}>
          <span style={{ color: "#008EA1" }}>Price</span>
        </Grid>

        {items.map((obj, i) => {
          return (
            <>
              <Grid item xs={6}>
                <span className="summaryLabelCls">{obj?.name}</span>
              </Grid>
              <Grid item xs={3}>
                <span className="summaryLabelCls">{obj?.quantity}</span>
              </Grid>
              <Grid item xs={3}>
                <span className="summaryLabelCls">R {obj?.price}</span>
              </Grid>{" "}
            </>
          );
        })}
      </Grid>
      <Grid container className="border" spacing={2} pt={0} pb={2} pl={4}>
        <Grid item xs={6}>
          <span style={{
            fontWeight: "bold",
          }}>TOTAL</span>
        </Grid>
        <Grid item xs={3}>
          <span style={{ color: "#008EA1" }}></span>
        </Grid>
        <Grid item xs={3}>
          <span style={{
            color: "#0D5C75",
            fontWeight: "bold",
          }}>  R 41.20</span>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Items;